import { ModalProps } from '@/types/shared'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { Button, Dialog } from 'vnetwork-ui'

export interface TenderPotentialModalProps extends ModalProps {
    prevReason: string | null
    onResolve: (not_potential_reason: string | null) => void
}

const TenderPotentialModal: React.FC<TenderPotentialModalProps> = ({
    onClose,
    open,
    onResolve,
    prevReason,
}) => {
    const { t } = useTranslation('tenders')
    const [reason, setReason] = useState<string | null>(prevReason)
    const actions = (
        <div className="flex space-x-2">
            <Button
                variant="outlined"
                onClick={() => {
                    onResolve(null)
                    onClose()
                }}
            >
                {t('cancel')}
            </Button>
            <Button
                onClick={() => {
                    if (!reason) {
                        toast.error(t('not_potential_reason_required'))
                        return
                    }
                    onResolve(reason)
                    onClose()
                }}
            >
                {t('set_reason')}
            </Button>
        </div>
    )
    return (
        <Dialog
            onClose={onClose}
            open={open}
            title={t('not_potential_modal_title')}
            actions={actions}
        >
            <textarea
                className="w-full border border-gray-300 rounded-md p-2"
                autoFocus
                placeholder={t('not_potential_reason_placeholder')}
                value={reason ?? ''}
                onChange={(e) => setReason(e.target.value)}
            />
        </Dialog>
    )
}

export default TenderPotentialModal
